import React from "react"
import types from "prop-types"
import { SidebarVisibilityControl } from "shared/Sidebar"
import NewReportModal from "../NewReportModal"

const ReportsHeader = ({ hiddenSidebar, toggleSidebar }) => (
  <div className="flex items-center justify-between mb-8">
    <SidebarVisibilityControl hiddenSidebar={hiddenSidebar} toggleSidebar={toggleSidebar} />
    <h1 className="header-title tracking-tight my-0">Self-Service Reports</h1>
    <NewReportModal />
  </div>
)

ReportsHeader.propTypes = {
  hiddenSidebar: types.bool.isRequired,
  toggleSidebar: types.func.isRequired,
}

export default ReportsHeader
